module.exports = __webpack_public_path__ + "static/media/editIcon.49189b67.svg";